module.exports = __webpack_public_path__ + "static/Logo12-2cf7d0961c31b88e1f28dc1f86ba050b.png";